export default {
  title: 'Diccionarios',

  states: {
    loading: 'Cargado {count}.',
    processing: 'Procesando...',
    import: 'Importadas {count} filas.',
    done: 'Importadas {count} filas.'
  },

  dialogs: {
    create: 'Crear nueva clave',

    titles: {
      remove: 'Confirmar eliminación del diccionario'
    }
  },

  new: {
    key: 'Nueva clave'
  },

  titles: {
    'phone:mnp': 'MNP',
    'phone:ranges': 'Prefijos',
    'phone:opgroups': 'Grupos de operadores',
    upload: 'Subir',
    import: 'Importar',
    mix: '¿Mezclar prefijos del servidor del socio?',
    createGroup: 'Crear grupo de operadores',
    group: 'Grupo',
    operator: 'Operador',
    number: 'Número',
    mcc: 'MCC',
    mnc: 'MNC',

    service: {
      mnp: 'MNP',
      ranges: 'Rangos',
      operatorGroups: 'Grupos de operadores'
    }
  },

  labels: {
    key: 'Clave',
    opcode: 'Código de operador',
    group: 'Grupo',
    groupName: 'Nombre del grupo',
    operatorName: 'Nombre del operador',
    operator: 'Operador',
    number: 'Número',
    region: 'Región',
    prefix: 'Prefijo',
    mcc: 'MCC',
    mnc: 'MNC',
    type: 'Tipo de diccionario',
    regionCode: 'Código de región',
    regionName: 'Nombre de la región',
    countryCode: 'Código de país',
    countryName: 'Nombre del país',
    timeZone: 'Zona horaria',
    status: 'Estado',
    OwnerId: 'Propietario',
    total: 'Total: {total}',

    ranges: {
      start: 'Inicio del rango',
      end: 'Fin del rango'
    },

    choose: {
      dictionary: 'Seleccionar diccionario',
      key: 'Introducir clave'
    },

    search: {
      keys: 'Buscar por claves'
    }
  },

  hints: {
    noItems: 'No hay diccionarios para mostrar',
    loading: 'No cierre ni recargue la ventana mientras se procesa la importación.',
    importOr: 'O seleccione un archivo en el administrador de archivos',

    empty: {
      default: 'Aquí aparecerán los resultados de la búsqueda',
      search: 'No se encontraron datos para este número'
    }
  },

  buttons: {
    compile: 'Compilar',
    set: 'Activar',
    unset: 'Desactivar',

    add: {
      range: 'Agregar rango'
    }
  },

  contents: {
    confirm: {
      remove: {
        dictionary: '¿Está seguro de que desea eliminar el diccionario {title}?',
        key: '¿Está seguro de que desea eliminar la clave {title}?'
      }
    }
  },

  snackbars: {
    updated: 'Diccionario actualizado con éxito.',

    dictionary: {
      created: 'Diccionario creado con éxito.',
      compile: 'Diccionario compilado con éxito.',
      updated: 'Diccionario actualizado con éxito.',
      removed: 'Diccionario eliminado con éxito.'
    },
    key: {
      created: 'Clave en el diccionario creada con éxito.',
      updated: 'Clave en el diccionario actualizada con éxito.',
      removed: 'Clave en el diccionario eliminada con éxito.'
    }
  },

  statuses: {
    created: 'Creado',
    ready: 'Listo',
    downloading: 'Descargando',
    importing: 'Importando',
    importError: 'Error durante la importación',
    compiling: 'Compilando',
    compiled: 'Compilado',
    compileError: 'Error durante la compilación',
    activated: 'Activado'
  },

  tooltips: {
    info: 'Detalles sobre el formato del archivo CSV',

    upload: {
      file: 'Importar desde archivo',
      partner: 'Importar desde el servidor del socio'
    }
  },

  filters: {
    items: {
      default: 'Diccionarios del sistema'
    }
  },

  info: {
    hint: 'Los nombres de las columnas distinguen entre mayúsculas y minúsculas',

    rows: {
      Number: 'número de teléfono',
      OwnerId: 'nombre del operador',
      MCC: 'MCC',
      MNC: 'MNC',
      NumberFrom: 'número de teléfono donde comienza el rango',
      NumberTo: 'número de teléfono donde termina el rango',
      RegionCode: 'código de región',
      GROUP: 'nombre del grupo',
      OrgCode: 'nombre del operador',
      TYPE: 'tipo de número de teléfono (ciudad ABC, móvil DEF)'
    }
  }
}
